module.exports = __webpack_public_path__ + "img/analytics_icon.1ad59230.svg";